// src/pages/Contact.jsx
// The Desk: contact page.
// Two sections: a controlled form that opens the visitor's email client via
// mailto: on submit, and a simple list of direct contact channels.
import { useState } from "react";

const CONTACT_EMAIL = "hello@example.com";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    const subject = `Letter from ${name || "a reader"}`;
    const body = `From: ${name} <${email}>\n\n${message}`;
    const mailtoUrl =
      `mailto:${CONTACT_EMAIL}` +
      `?subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoUrl;
  }

  const inputClasses =
    "w-full bg-transparent border-0 border-b border-ink-20 py-3 text-body text-ink focus:outline-none focus:border-ink transition-colors";

  return (
    <>
      {/* Page header */}
      <section className="max-w-wide mx-auto px-6 pt-20 pb-12 md:pt-28 md:pb-16">
        <p className="label-mono">The Desk</p>
        <h1 className="font-display text-h2 leading-tight font-medium mt-3">
          Correspondence
        </h1>
        <p className="text-body text-ink-70 leading-relaxed mt-6 max-w-2xl">
          For consulting, collaboration, or simple curiosity, the door is open.
          A note below, or directly to the address on the right.
        </p>
      </section>

      <hr className="hairline max-w-wide mx-auto" />

      {/* Form + Direct contact */}
      <section className="max-w-wide mx-auto px-6 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          {/* Form */}
          <div className="md:col-span-8">
            <p className="label-mono mb-8">A note to the editor</p>
            <form onSubmit={handleSubmit} className="space-y-8">
              <div>
                <label htmlFor="name" className="label-mono block mb-2">
                  Name
                </label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className={inputClasses}
                />
              </div>
              <div>
                <label htmlFor="email" className="label-mono block mb-2">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className={inputClasses}
                />
              </div>
              <div>
                <label htmlFor="message" className="label-mono block mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  rows="6"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  className={inputClasses + " resize-none"}
                />
              </div>
              <div className="pt-4">
                <button
                  type="submit"
                  className="label-mono border-b border-ink hover:text-oxblood hover:border-oxblood transition-colors py-2"
                >
                  Send →
                </button>
              </div>
            </form>
          </div>

          {/* Direct */}
          <div className="md:col-span-4">
            <p className="label-mono mb-8">Direct</p>
            <ul className="space-y-4">
              <li>
                <p className="label-mono mb-1">Email</p>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="text-body hover:text-oxblood transition-colors"
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li>
                <p className="label-mono mb-1">GitHub</p>
                <a
                  href="https://github.com"
                  className="text-body hover:text-oxblood transition-colors"
                >
                  @sandra-hershey-zagrans
                </a>
              </li>
              <li>
                <p className="label-mono mb-1">LinkedIn</p>
                <a
                  href="https://linkedin.com"
                  className="text-body hover:text-oxblood transition-colors"
                >
                  Sandra Hershey-Zagrans
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
